export const getFormat = (file) => file.name.split('.').slice(-1)[0];
export const getFileTypesBasedOnAllowedUploads = (allowedUploads) =>
  allowedUploads?.map((upload) => `.${upload.toLowerCase()}`);
